document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        pageLoaded();
    }, 0)
})

const bodyTemplate = document.querySelector('body');
bodyTemplate.classList.add('stop-scrolling');

const pageLoaded = () =>{
    setTimeout(() => {
        let loaderSection = document.querySelector('.load-content');
        loaderSection.classList.add('loaded');
        bodyTemplate.classList.remove('stop-scrolling');
    }, 0);
    // }, 0);
}